import { bool } from 'prop-types';
import React from 'react';

/**
 * This checkbox behaves just like the original input dom element, but it
 * provides declarative access to the `indeterminate` DOM property.
 */

class Checkbox extends React.Component {
  constructor(props) {
    super(props);

    this.input = React.createRef();
  }

  componentDidMount() {
    this.updateDOM();
  }

  componentDidUpdate() {
    this.updateDOM();
  }

  updateDOM() {
    const { indeterminate } = this.props;
    if (
      this.input.current &&
      this.input.current.indeterminate !== indeterminate
    ) {
      this.input.current.indeterminate = indeterminate;
    }
  }

  render() {
    const { indeterminate, ...rest } = this.props;
    return <input type="checkbox" {...rest} ref={this.input} />;
  }
}

Checkbox.propTypes = {
  indeterminate: bool,
};

Checkbox.defaultProps = {
  indeterminate: false,
};

export default Checkbox;
